import {
  REQUEST_SUBSCRIPTION_INFO_SUCCESS, REQUEST_SUBSCRIPTION_INFO_FAILURE,
  REQUEST_USER_PACKAGE_INFO_SUCCESS, REQUEST_USER_PACKAGE_INFO_FAILURE
} from '../constants/actionTypes';

const INITIAL_STATE = {};

export default function subscription(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_SUBSCRIPTION_INFO_SUCCESS:
      return { ...state, ...action.payload.data, errors: null }
    case REQUEST_SUBSCRIPTION_INFO_FAILURE:
      return { ...state, errors_stripe_sub: action.payload }
    case REQUEST_USER_PACKAGE_INFO_SUCCESS:
      return { ...state, UserPackageInfo: action.payload.data, errors_user_sub: null }
    case REQUEST_USER_PACKAGE_INFO_FAILURE:
      return { ...state, errors_user_sub: action.payload }
    default:
      return state;
  }
}
